import React, { useState, useEffect } from 'react';
import { getBulkSearchFormFields } from '../searchStudent/constants';
import { getInputField } from '../../../../components/AFilterForm/FormFields';
import AButton from '../../../../views/pages/manage/common/form-fields-mui/AButton';
import { useGetBUByBUType, useGetCourseIdsForBUAndTerm } from '../../../../views/pages/manage/edpOps/stockManagement/customhooks';
import useCashierOfficeDropdown from '../../../../views/pages/manage/common/hook/useCashierOfficeDropdown';

const FilterForm = ({ formModal = {}, inputHandler, dropdowns }) => {


    const [localForm, setLocalForm] = useState(formModal);

    const [courseIdDropdown, courseIdDropdownLoading] =
        useGetCourseIdsForBUAndTerm({
            businessArea: localForm?.businessArea,
            term: localForm?.term,
        });

    const [buDropdown, buDropdownLoading] = useGetBUByBUType(localForm?.branchType);

    const handleLocalChange = (field, value) => {
        setLocalForm((prev) => ({ ...prev, [field]: value }));
    };

    const { items: cashierOfficeDropdownData, disabled: cashierOfficeDropdownDisabled } = useCashierOfficeDropdown({ businessArea: localForm?.businessArea, formHandler: handleLocalChange })

    const formFields = getBulkSearchFormFields({
        ...dropdowns,
        courseIdDropdown,
        courseIdDropdownLoading,
        buDropdown,
        buDropdownLoading,
        filterForm: localForm,
        setFilterForm: setLocalForm,
        cashierOfficeDropdownData,
        cashierOfficeDropdownDisabled
    }
    );

    const applyFilter = () => {
        inputHandler(localForm); // Send updated state back to parent
    };

    useEffect(() => {
        setLocalForm(formModal);
    }, [formModal]);

    return (
        <div className='d-flex flex-column p-3' style={{ width: '310px' }}>
            <h3>Filters</h3>
            {formFields?.map(formField => getInputField(formField, handleLocalChange, localForm))}
            <AButton
                variant='primary_filled'
                onClick={applyFilter}
                className='no-ml-btn mt-2'
            >
                Apply
            </AButton>
        </div>
    );
}

export default FilterForm;